import { DPR_1, DPR_2 } from '../constants';

const CLOUDINARY_PATH = 'https://fiverr-res.cloudinary.com/image/upload';
const ASSET_PATH = 'v1/attachments/generic_asset/asset'; // Houston production upload path

interface ImgPathWithTransformsProps {
    width: string;
    dpr: string;
    img: string;
}

interface ImgSrcSetProps {
    width: string;
    img: string;
}

interface ImgSrcSetFullProps {
    width: string;
    img: string;
    retinaImg?: string;
}

const imgPathWithTransforms = ({ width, dpr, img }: ImgPathWithTransformsProps): string => {
    const imgTransform = `q_auto,f_auto,w_${width},${dpr}`;

    return `${CLOUDINARY_PATH}/${imgTransform}/${ASSET_PATH}/${img}`;
};

const imgSrcSet = ({ width, img }: ImgSrcSetProps): string => `${imgPathWithTransforms({ width, dpr: DPR_1, img })} 1x`;
const imgSrcSetRetina = ({ width, img }: ImgSrcSetProps): string =>
    `${imgPathWithTransforms({ width, dpr: DPR_2, img })} 2x`;

const imgSrcSetFull = ({ width, img, retinaImg }: ImgSrcSetFullProps): string =>
    `${imgSrcSet({ width, img })}, ${imgSrcSetRetina({ width, img: retinaImg ? retinaImg : img })}`;

export { imgPathWithTransforms, imgSrcSet, imgSrcSetRetina, imgSrcSetFull };
